import { PageLayout, TertiaryBar } from '@kcftech/design-system';
import { NavTabLink } from 'components/tabs/NavTabs';
import { TabRouter } from 'components/tabs/TabRouter';
import { useRouteTabs } from 'custom_hooks/data_hooks/data_source/useRouteTabs';
import { ManufacturersPage } from 'pages/Settings/ThirdPartySensorModels/ManufacturersPage/ManufacturersPage';
import { ThirdPartySensorModelsTab } from 'pages/Settings/ThirdPartySensorModels/ThirdPartySensorModelsTab';
import { useMemo } from 'react';
import { ContextualPageProps } from 'utils/types';

const getTabs = () => [
    {
        id: 'manufacturers',
        label: 'Manufacturers',
        content: <ManufacturersPage />,
    },
    {
        id: 'sensorModels',
        label: 'Sensor Models',
        content: <ThirdPartySensorModelsTab />,
    },
];

export function ThirdPartySensorsPage(_unusedProps: ContextualPageProps) {
    const { routeTabs } = useRouteTabs(useMemo(() => getTabs(), []));

    return (
        <>
            <PageLayout.Tertiary className="scrollable-x">
                <TertiaryBar.Navigation>
                    <TertiaryBar.Items>
                        <TertiaryBar.Item>
                            {routeTabs.map(({ id, url, label }) => (
                                <NavTabLink key={id} to={url} className="p-10">
                                    {label}
                                </NavTabLink>
                            ))}
                        </TertiaryBar.Item>
                    </TertiaryBar.Items>
                </TertiaryBar.Navigation>
            </PageLayout.Tertiary>
            <TabRouter routeTabs={routeTabs} />
        </>
    );
}
